import cn from "classnames";
import SelectMacStages from "@vms/SelectFilters/SelectMacStages";
import SearchForFilters from "@vms/SelectFilters/SearchForFilters";
import SelectCategories from "@vms/SelectFilters/SelectCategories";
import { Button, ButtonType, FCX } from "@datassential/platform-ui-lib";
import Modal from "@components/Modal";
import SelectHeatScores from "@vms/SelectFilters/SelectHeatScores";

const SelectFiltersModal: FCX<{
	onClose: () => void;
	cancelFilters: () => void;
	applyFilters: () => void;
	resetFilters: () => void;
}> = ({
	className,
	onClose,
	cancelFilters,
	applyFilters,
	resetFilters,
	...props
}) => {
	return (
		<Modal
			onClose={cancelFilters}
			modifiers={['no-pad']}
			className={
				cn(
					"SelectFiltersModal",
					className
				)
			}
			{...props}
		>
			<div className="SelectFiltersModal__container">
				<div className="SelectFiltersModal__content">
					<SelectMacStages />
					<SelectHeatScores />
					<SearchForFilters />
					<SelectCategories />
				</div>
				<div className="Modal__footer">
					<div/>
					<div className="Modal__footer-part">
					<Button
						type={ButtonType.Button}
						modifiers={["naked"]}
						onClick={resetFilters}
						testId="buttonCancelSelectFilters"
					>
						Clear All
					</Button>
					<Button
						type={ButtonType.Button}
						onClick={applyFilters}
						testId="buttonApplySelectFilters"
					>
						Apply
					</Button>
					</div>
				</div>
			</div>
		</Modal>
	)
}

export default SelectFiltersModal;
